import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/home/prev-icon.png'
import _imports_1 from '@/assets/images/beian-icon.png'
import _imports_2 from '@/assets/images/code1.png'
import _imports_3 from '@/assets/images/code2.png'


const _hoisted_1 = { class: "bottom-box" }
const _hoisted_2 = ["onClick"]

import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomNavigation',
  setup(__props) {

const router = useRouter()

const routerList = [
  {
    title: '混空Studio',
    url: '/studio'
  },
  {
    title: '混空VPS',
    url: '/vps'
  },
  {
    title: '通用解决方案',
    url: '/solution2'
  },
  {
    title: '行业解决方案',
    url: '/solution'
  },
  {
    title: '关于我们',
    url: '/about-us'
  },
  {
    title: '合作咨询',
    url: '/counselling'
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routerList, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          onClick: ($event: any) => (_unref(router).push(item.url))
        }, [
          _createElementVNode("span", null, _toDisplayString(item.title), 1),
          _cache[0] || (_cache[0] = _createElementVNode("img", { src: _imports_0 }, null, -1))
        ], 8, _hoisted_2)
      }), 64))
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"bottom-box-text\" data-v-62fac1b3><div data-v-62fac1b3><div data-v-62fac1b3>上海市徐汇区钦州北路1001号光启园7号楼6层</div><div data-v-62fac1b3>沪ICP备2023012463号—1</div><div data-v-62fac1b3>版权所有 ©️ 2023上海凝聚元界信息科技有限公司</div><div data-v-62fac1b3><img src=\"" + _imports_1 + "\" data-v-62fac1b3><span data-v-62fac1b3>沪公网安备 31010402010108号</span></div></div><div data-v-62fac1b3><div data-v-62fac1b3><img src=\"" + _imports_2 + "\" data-v-62fac1b3><div data-v-62fac1b3>公众号</div></div><div data-v-62fac1b3><img src=\"" + _imports_3 + "\" data-v-62fac1b3><div data-v-62fac1b3>视频号</div></div></div></div>", 1))
  ]))
}
}

})